import { render } from "./ProductsCRUD.vue?vue&type=template&id=ec6a8b46&scoped=true"
import script from "./ProductsCRUD.vue?vue&type=script&lang=js"
export * from "./ProductsCRUD.vue?vue&type=script&lang=js"

import "./ProductsCRUD.vue?vue&type=style&index=0&id=ec6a8b46&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6a8b46"]])

export default __exports__